import enTranslationSurveyStatus from "./en/translation-survey-status.json";
import enTranslationProjects from "./en/translation-projects.json";
import enTranslationManageUsers from "./en/translation-manage-users.json";
import enTranslationSurveyLinkStatus from "./en/translation-survey-link-status.json";
import enTranslationFilters from "./en/translation-filters.json";
import enTranslationWelcomePage from "./en/translation-welcome-page.json";
import enTranslationSurveyDashboard from "./en/translation-survey-dashboard.json";
import enTranslationErrors from "./en/translation-errors.json";
import enTranslationSurveys from "./en/translation-surveys.json";
import enTranslationCommon from "./en/translation-common.json";
import enTranslationSurveyRespondentErrors from "./en/translation-survey-respondent-errors.json";

export const eagleEnTranslation = {
  surveyStatus: enTranslationSurveyStatus,
  projects: enTranslationProjects,
  manageUsers: enTranslationManageUsers,
  surveyLinkStatus: enTranslationSurveyLinkStatus,
  filters: enTranslationFilters,
  welcomePage: enTranslationWelcomePage,
  surveyDashboard: enTranslationSurveyDashboard,
  errors: enTranslationErrors,
  surveys: enTranslationSurveys,
  common: enTranslationCommon,
  surveyRespondentErrors: enTranslationSurveyRespondentErrors,
};
